import { render, staticRenderFns } from "./EditprofilepagePage.vue?vue&type=template&id=729089ce"
import script from "./EditprofilepagePage.vue?vue&type=script&lang=js"
export * from "./EditprofilepagePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports